import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, catchError, map } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { getDeleteOptionsObject } from '../../utils/api';
import { DELETE_SPOUSE } from './actions';
import { deleteSpouseSuccess, deleteSpouseError } from '../spouse/actions';

export const deleteSpouse: Epic = action$ =>
  action$.pipe(
    ofType(DELETE_SPOUSE),
    flatMap(() =>
      ajax(getDeleteOptionsObject('/retirement-income-ui/service/spouse'))
        .pipe(map((res: any) => deleteSpouseSuccess(res.response)))
        .pipe(catchError(ex => of(deleteSpouseError(ex)))),
    ),
  );
